/** Client-side column sorters for Dynamic Bonuses list tables. */

export const compareStrings = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => (a ?? "").localeCompare(b ?? "", undefined, { sensitivity: "base" });

export const compareNumbers = (
  a: number | null | undefined,
  b: number | null | undefined,
): number => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return a - b;
};

export const compareIsoDates = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return Date.parse(a) - Date.parse(b);
};
